export const SUBSCRIPTION_PLAN_TYPES = {
    GIG_LIMIT_TIME_UNLIMITED: "gig-limit-time-unlimited",
    GIG_UNLIMITED_TIME_LIMIT: "gig-unlimited-time-limit",
    GIG_LIMIT_TIME_LIMIT: "gig-limit-time-limit",
};
export const SUBSCRIPTION_PLAN_TYPE_VALUES = Object.values(SUBSCRIPTION_PLAN_TYPES);
export const SUBSCRIPTION_PLAN_DISPLAY_NAMES = {
    [SUBSCRIPTION_PLAN_TYPES.GIG_LIMIT_TIME_UNLIMITED]: "حجم محدود - زمان نامحدود",
    [SUBSCRIPTION_PLAN_TYPES.GIG_UNLIMITED_TIME_LIMIT]: "حجم نامحدود - زمان محدود",
    [SUBSCRIPTION_PLAN_TYPES.GIG_LIMIT_TIME_LIMIT]: "حجم محدود - زمان محدود",
};
export const SUBSCRIPTION_STATUSES = {
    ACTIVE: "active",
    DISABLED: "disabled",
    WAITING_FOR_REVIEW: "waiting-for-review",
};
export const SUBSCRIPTION_STATUS_VALUES = Object.values(SUBSCRIPTION_STATUSES);
export const SUBSCRIPTION_STATUS_DISPLAY_NAMES = {
    [SUBSCRIPTION_STATUSES.ACTIVE]: "فعال",
    [SUBSCRIPTION_STATUSES.DISABLED]: "غیرفعال",
    [SUBSCRIPTION_STATUSES.WAITING_FOR_REVIEW]: "در انتظار بررسی",
};
export const SUBSCRIPTION_STATUS_COLORS = {
    [SUBSCRIPTION_STATUSES.ACTIVE]: "success",
    [SUBSCRIPTION_STATUSES.DISABLED]: "error",
    [SUBSCRIPTION_STATUSES.WAITING_FOR_REVIEW]: "warning",
};
export const SUBSCRIPTION_PLAN_DEFAULTS = {
    [SUBSCRIPTION_PLAN_TYPES.GIG_LIMIT_TIME_UNLIMITED]: {
        gigLimit: 100,
        timeLimit: 0,
    },
    [SUBSCRIPTION_PLAN_TYPES.GIG_UNLIMITED_TIME_LIMIT]: {
        gigLimit: 0,
        timeLimit: 1,
    },
    [SUBSCRIPTION_PLAN_TYPES.GIG_LIMIT_TIME_LIMIT]: {
        gigLimit: 50,
        timeLimit: 1,
    },
};
export const SUBSCRIPTION_LIMITS = {
    GIG_LIMIT: {
        MIN: 1,
        MAX: 1000,
    },
    TIME_LIMIT: {
        MIN: 1,
        MAX: 12,
    },
};
export const getPlanDisplayName = (planType) => {
    return SUBSCRIPTION_PLAN_DISPLAY_NAMES[planType] || planType;
};
export const getStatusDisplayName = (status) => {
    return SUBSCRIPTION_STATUS_DISPLAY_NAMES[status] || status;
};
export const getStatusColor = (status) => {
    return SUBSCRIPTION_STATUS_COLORS[status] || "default";
};
export const getPlanDefaults = (planType) => {
    return SUBSCRIPTION_PLAN_DEFAULTS[planType] || { gigLimit: 0, timeLimit: 0 };
};
export const isGigLimitPlan = (planType) => {
    return planType === SUBSCRIPTION_PLAN_TYPES.GIG_LIMIT_TIME_UNLIMITED ||
        planType === SUBSCRIPTION_PLAN_TYPES.GIG_LIMIT_TIME_LIMIT;
};
export const isTimeLimitPlan = (planType) => {
    return planType === SUBSCRIPTION_PLAN_TYPES.GIG_UNLIMITED_TIME_LIMIT ||
        planType === SUBSCRIPTION_PLAN_TYPES.GIG_LIMIT_TIME_LIMIT;
};
